import { breakPointsHelper } from '../../components/mixin/breakPointsHelpers'
import Vue from 'vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export const carouselBase = {
  mixins: [breakPointsHelper],
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    slidesPerView: {
      type: Number,
      default: 4
    },
    mobileSlidesPerView: {
      type: Number,
      default: 1
    },
    maxItems: {
      type: Number,
      default: 11
    },
    seeAllLinkTo: {
      type: String,
      default: ''
    },
    isProduct: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    slideChange
  },
  data() {
    return {
      disablePrev: true,
      disableNext: false,
      reInitializeSwiper: false
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    swiperOptions() {
      let slidesPerView = this.windowWidth > this.breakpoints.md ? this.slidesPerView : this.mobileSlidesPerView

      if (this.underBreakpoint('md') && this.isProduct) {
        slidesPerView = 'auto'
      }

      return {
        margin: 24,
        slidesPerView,
        spaceBetween: window.innerWidth < this.breakpoints.md ? 16 : 24,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'hide'
        }
      }
    }
  },
  watch: {
    'swiperOptions.slidesPerView': async function () {
      this.reInitializeSwiper = true
      await Vue.nextTick()
      this.reInitializeSwiper = false
    }
  }
}

function slideChange() {
  setTimeout(() => {
    this.disablePrev = this.swiper.isBeginning
    this.disableNext = this.swiper.isEnd
  })
}
